<template>
    <div style="padding-bottom: 70px;">
        <div class="banner">
            <img alt="" src="../../assets/frontend/images/sban4.jpg"/>
        </div>
        <div class="page-main">
            <div class="page-header">
                <h2>关于我们</h2>
                <div class="icon-xian"></div>
            </div>
            <div class="content">
                <img alt="" class="about-img" src="../../assets/frontend/images/about.jpg"/>
                <div class="desc" style="text-indent: 2em; padding-top:20px;">
                    {{service.aboutUs}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'about',
        data() {
            return {
                service: {}
            }
        },
        mounted() {
            this.getAppSetting();
        },
        methods: {
            getAppSetting() {
                this.showPcLoading();
                this.$axios.get(window.consts.apis.getAppSetting).then(res => {
                    this.hidePcLoading();
                    if (res.success) {
                        this.service = res.result;
                    }
                }).catch(e => {
                    this.hidePcLoading();
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .banner img {
        width: 100%;
        max-width: 1920px;
    }

    .page-main {
        position: relative;
        width: 1200px;
        background: white;
        margin: -180px auto auto;
        -moz-box-shadow: 0 3px 8px rgba(194, 209, 197, .4);
        -webkit-box-shadow: 0 3px 8px rgba(194, 209, 197, .4);
        box-shadow: 0 3px 8px rgba(194, 209, 197, .4);

        .content {
            width: 930px;
            margin: 20px auto 0;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding-bottom: 50px;

            .about-img {
                display: block;
                width: 358px;
                height: 249px;
                margin-top: 26px;
            }

            .desc {
                width: 500px;
                font-size: 18px;
                line-height: 32px;
            }
        }

    }
</style>
